import React from 'react'
import { Popover } from '@mui/material'

type AdvancedFilterPopoverProps = {
  anchorEl: HTMLButtonElement | null
  setAnchorEl: (element: HTMLButtonElement | null) => void
  onUnfocused: () => void
}

export const AdvancedFilterPopover: React.FC<AdvancedFilterPopoverProps> = ({
  children,
  anchorEl,
  setAnchorEl,
  onUnfocused,
}) => {
  const handleClose = () => {
    setAnchorEl(null)
    onUnfocused()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      {children}
    </Popover>
  )
}
